export type WooErrorType = {
  response?: {
    data?: {
      message?: string;
      error?: {
        code?: string;
        message?: string;
        data?: {
          status?: number;
        };
      };
    };
    status?: number;
  };
  code?: string;
  message?: string;
  name?: string;
};

export type ErrorType = {
  error: {
    message: string;
    title: string;
    status: number;
    error: any;
    code: string;
  };
};

export const parseWooError = (error: WooErrorType) => {
  const wooError = error.response?.data?.error;
  const fallbackMessage = error.response?.data?.message ?? error.message;

  if (error.code === "ERR_CANCELED") return null;

  return {
    message:
      wooError?.message ?? fallbackMessage ?? "Oops! Something went wrong.",
    title: "WooCommerce Error",
    status: wooError?.data?.status ?? error.response?.status ?? 500,
    code: wooError?.code ?? error.code ?? "unknown_woocommerce_error",
    error: wooError ?? error,
  };
};

export const parseError = (error: ErrorType) => {
  if (error.error?.code === "ERR_CANCELED") return null;

  return {
    message: error.error?.message ?? "Oops! Something Went Wrong.",
    title: error.error?.title ?? "Error",
    status: error.error?.status ?? 504,
    code: error.error?.code ?? "Unknown Error",
    error: error.error,
  };
};

export const retry = (fn: any, retries: number = 2) => {
  return async function (...args: any[]) {
    let attempts = 0;
    while (attempts < retries) {
      try {
        return await fn(...args);
      } catch (error) {
        attempts++;
        if (attempts >= retries) {
          throw parseError(error as ErrorType);
        }
      }
    }
  };
};
